const config = {
    driverDelegateLetter: {
        'bigData-btn-search': '工作台,司机管理,司机委派函管理,查询',
        'bigData-btn-export': '工作台,司机管理,司机委派函管理,导出',
        'bigData-btn-add': '工作台,司机管理,司机委派函管理,发起供应商签署',
    },
}
export default config
